export default __webpack_public_path__ + "static/media/navbar-payment-pending-dark.86e2a48f.svg";